import React, { useState } from "react";
import Societies from "../../component/Societies/Societies";
import banner from "../../asset/Approved banner.png";
import { useGetApprovedSocietiesQuery } from "../../Redux/getApi";
import { useDebounce } from "use-debounce";

const ApprovedSocieties = () => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [debouncedSearch] = useDebounce(search, 1500);

  const { data, error, isLoading, isFetching } = useGetApprovedSocietiesQuery({
    page,
    search: debouncedSearch,
  });

  const approvedSocieties = data?.societies;
  const totalPages = data?.totalPages;
  const currentPage = data?.currentPage;
  const totalSocieties = data?.totalSocieties;

  return (
    <div>
      <Societies
        societies={approvedSocieties}
        bgColor="#DEE9E4"
        color="#00643B"
        banner={banner}
        name="Approved Housing Societies"
        error={error}
        isLoading={isLoading}
        isFetching={isFetching}
        totalPages={totalPages}
        currentPage={currentPage}
        search={search}
        setSearch={setSearch}
        page={page}
        setPage={setPage}
        societyStatus="approved"
        totalSocieties={totalSocieties}
      />
    </div>
  );
};

export default ApprovedSocieties;
